import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GetAllQuery, PatientApi, PatientListDto } from 'src/app/services/api-service/patient/patient-api';
import { PatientsDto, QueryPatient } from 'src/app/services/api-service/patient/patientsDto';
import { HcrService } from 'src/app/services/hcr-service.service';
import { PatientInfoWindowService } from 'src/app/services/patient-info-window.service';

@Component({
  selector: 'app-patients-patient-query-dialog',
  templateUrl: './patient-query-dialog.component.html',
  styleUrls: ['./patient-query-dialog.component.css']
})
export class PatientQueryDialogComponent implements OnInit {

  _isDialogOpened = false;
  @Input() set isDialogOpened(value: boolean) {
    this._isDialogOpened = value;
    if (value) {
      this.selectedPatient = null;
      this.loadInitialPatientsFromPatientInfoWindow();
    }
  }

  @Input()
  demoIc: boolean = false;

  @Input()
  vIc: boolean = false;
  @Input()
  initCondition: {CName:string,CId:string,Mobile:string,Birthday:Date} = null;
  
  @Output() onEmitResult = new EventEmitter<PatientListDto>();
  @Output() onEmitICResult = new EventEmitter<PatientListDto>();
  @Output() onEmitIC = new EventEmitter();
  @Output() onEmitQR = new EventEmitter();
  @Output() onEmitQueryNotFound = new EventEmitter<QueryPatient>();

  selectedPatient: PatientListDto;
  initialPatients: PatientListDto[] = [];
  private initialPatientLoadToken = 0;

  constructor(
    private hcrService: HcrService,
    private patientApi: PatientApi,
    private patientInfoWindowService: PatientInfoWindowService) { }

  get isDisableBtnSelect() {
    if (!this.selectedPatient || !this.selectedPatient.Id) {
      return true;
    } else {
      return false;
    }
  }

  ngOnInit() {
    this.loadInitialPatientsFromPatientInfoWindow();
  }

  onDialogClose(status: string) {
    if (status === 'ok') {
      this.onEmitResult.emit(this.selectedPatient);
    }
    // DemoMode才會開啟這個按鈕
    else if (status === 'ic') {
      this.hcrService.setDemoPatient({
        CName: this.selectedPatient.Name,
        Id: this.selectedPatient.Id,
        CId: this.selectedPatient.CId,
        Birthday: this.selectedPatient.Birthday,
        PatientNo: this.selectedPatient.PatientNo,
        Sex: this.selectedPatient.Sex
      })
      this.onEmitICResult.emit(this.selectedPatient);
    } 
    else if (status === 'QR') {
      this.onEmitQR.emit();
    }else {
      // 這次沒選任何病患
      this.onEmitResult.emit(null);
    }
  }
  onDialogChose(event: PatientListDto) {
    this.onEmitResult.emit(event);
  }
  onQueryNotFound(event: QueryPatient) {
    this.onEmitQueryNotFound.emit(event);
  }

  receivePatientChange(event: PatientListDto) {
    this.selectedPatient = event;
    // NoPatient請參考patient-query的元件說明
    if (event != null && event.Id === 0) {
      this.onEmitResult.emit(event);
    }
  }

  private async loadInitialPatientsFromPatientInfoWindow() {
    const loadToken = ++this.initialPatientLoadToken;
    const patient = this.patientInfoWindowService.getRememberedSelectedPatient();
    if (!patient?.Id) {
      this.initialPatients = [];
      return;
    }

    this.initialPatients = [patient];

    const fullPatient = await this.getInitialPatientById(Number(patient.Id));
    if (loadToken !== this.initialPatientLoadToken || !this._isDialogOpened) {
      return;
    }

    if (!fullPatient) {
      return;
    }

    const normalizedPatient = Object.assign(new PatientListDto(), patient, fullPatient);
    this.initialPatients = [normalizedPatient];
    this.patientInfoWindowService.setSelectedPatient(normalizedPatient);
  }

  private async getInitialPatientById(patientId: number): Promise<PatientListDto | null> {
    if (!patientId) {
      return null;
    }

    try {
      const query = Object.assign(new GetAllQuery(), {
        Birthday: '',
        PatientNo: '',
        Name: '',
        PhoneNo: '',
        Mobile: '',
        CId: '',
        Address: '',
        Family: '',
        SearchType: '',
        PatientId: patientId,
        FuzzyQuery: '',
        FieldsToCheck: '',
        pageSkip: 0,
        pageSize: 1
      });
      const result = await this.patientApi.GetAll(query);
      const data = result?.Data?.data || [];
      return data.length ? Object.assign(new PatientListDto(), data[0]) : null;
    } catch (ex) {
      console.warn('Failed to load patient info window initial patient.', ex);
      return null;
    }
  }
}
